import useDevice from "src/hooks/useDevice";
import { paddingLarge, paddingXXXL } from "src/styles/spacing";
import { AnimatePresence } from "src/swsh-native";
import OpacityView from "../OpacityView";
import useModularNavBarSizing from "./hooks/useModularNavBarSizing";
import { ModularNavBarProps } from "./types";

const ModularNavBar = ({ renderItem, style }: ModularNavBarProps) => {
	const { Content, key, parentContainerStyle } = renderItem();
	const { height, top } = useModularNavBarSizing();

	const { device } = useDevice();

	return (
		<AnimatePresence>
			<OpacityView
				key={key}
				pointerEvents="box-none"
				style={[
					{
						flexDirection: "row",
						position: "absolute",
						width: "100%",
						paddingHorizontal: device === "desktop" ? paddingXXXL : paddingLarge,
						height,
						marginTop: top,
						alignItems: "center",
						justifyContent: "space-between",
						zIndex: 1,
					},
					style,
					parentContainerStyle,
				]}
			>
				{Content}
			</OpacityView>
		</AnimatePresence>
	);
};
export default ModularNavBar;
